module.exports = __webpack_public_path__ + "static/media/about-img-2.cf6c494a.jpg";